import { HeartHandshake, ShieldCheck, Sprout, Users, GraduationCap } from "lucide-react";
import { Reveal } from "./Reveal";

const PILLARS = [
  { name: "Faith", num: "01", icon: HeartHandshake },
  { name: "Integrity", num: "02", icon: ShieldCheck },
  { name: "Legacy", num: "03", icon: Sprout },
  { name: "Impact", num: "04", icon: Users },
  { name: "Scholarship", num: "05", icon: GraduationCap },
];

const Pillars = () => (
  <section id="values" data-testid="values-section" aria-labelledby="values-heading" className="parchment-noise relative overflow-hidden border-t border-parchborder py-24 sm:py-28">
    <div className="blueprint-grid-light absolute inset-0 opacity-40" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
        <h2 id="values-heading" className="font-serif text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Built On <em className="ember-text">Five Pillars</em>
        </h2>
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-royal/70 sm:text-[11px]" data-testid="values-sheet-label">
          Sheet VHE-04 — Structural Load-Bearing Values
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden border border-ember/20 bg-ember/20 sm:grid-cols-3 lg:grid-cols-5" role="list">
        {PILLARS.map((p, i) => (
          <Reveal key={p.name} delay={0.08 * i} className="h-full">
            <div
              role="listitem"
              data-testid={`pillar-${p.name.toLowerCase()}`}
              className="group flex h-full flex-col items-center gap-4 bg-parchment px-4 py-10 text-center transition-colors duration-500 hover:bg-navy"
            >
              <span className="font-mono text-[10px] tracking-[0.35em] text-ember transition-colors duration-500 group-hover:text-gold/70">{p.num}</span>
              <p.icon className="h-9 w-9 text-ember transition-all duration-500 group-hover:scale-110 group-hover:text-gold" strokeWidth={1.5} aria-hidden="true" />
              <span className="font-serif text-lg font-semibold text-ink transition-colors duration-500 group-hover:text-parchment">{p.name}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Pillars;
